import React, { FunctionComponent } from "react";

const Success: FunctionComponent = () => (
  <svg
    width={"24"}
    height={"24"}
    viewBox={"0 0 24 24"}
    fill={"none"}
    xmlns={"http://www.w3.org/2000/svg"}
  >
    <circle cx="12" cy="12" r="12" fill="#007AFF" />
    <path
      d="M15.6799 10L15.1487 10.5312L10.8995 14.7804L8.89982 12.7808L8.3999 12.2809"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Success;
